import { initServerTranslation } from '@bts-web/utils-lokalise';
import { getAcceptOrderTranslations } from './getTranslations';
import { OrderSummary } from './OrderSummary';
import { getOrderById } from '../../common/gqlActions/getOrderById.action';
import { AcceptOfferPageProps } from './AcceptOrder';
import { GenericErrorMessage } from '../../layouts/GenericErrorMessage/GenericErrorMessage';

export const AcceptOrderController = async (props: AcceptOfferPageProps) => {
  const { t, locale } = await initServerTranslation();

  if (!props.order && !props.orderId) {
    return <GenericErrorMessage />;
  }

  let currentOrder = props.order;

  if (!props.order && props.orderId) {
    const orderResult = await getOrderById(props.orderId);

    if ('errors' in orderResult) {
      return <GenericErrorMessage />;
    }

    currentOrder = orderResult.data;
  }

  if (!currentOrder) {
    return <GenericErrorMessage />;
  }

  const translations = getAcceptOrderTranslations(t);

  return (
    <OrderSummary
      translations={translations}
      order={currentOrder}
      locale={locale}
      t={t}
    />
  );
};
